const NON_BOOLEAN_PERMISSIONS = [
  'maximum_credit_authorized',
  'credit_types_authorized',
];

export default NON_BOOLEAN_PERMISSIONS;
